import { render, staticRenderFns } from "./NavBread.vue?vue&type=template&id=c48058b6&scoped=true"
import script from "./NavBread.vue?vue&type=script&lang=js"
export * from "./NavBread.vue?vue&type=script&lang=js"
import style0 from "./NavBread.vue?vue&type=style&index=0&id=c48058b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48058b6",
  null
  
)

export default component.exports